import { APP_FORM_KEYS } from "../Modules/MobileAppForm/constants/Form.constants";

export const MOBILE_APP_ROUTE_KEYS = {
  home: "home",
};

export const MOBILE_APP_ROUTE_IDS = {
  [MOBILE_APP_ROUTE_KEYS.home]: "/mobile-app",
};

export const MOBILE_APP_APIS = {
  CREATOR_MOBILE_APP_OFFER_DETAILS: "business/credits/creator/app/details/get",
};

export const APP_PURCHASE_STATUS = {
  PURCHASED: 1,
  DATA_SUBMITTED: 2,
  IN_PROGRESS: 3,
  LIVE: 4,
  DATA_UPDATE_REQUESTED: 5,
  DATA_UPDATED: 6,
  DATA_UPDATE_FAILED: 7,
};

export const APP_IN_PROCESS = {
  is_android_published: false,
  is_ios_published: false,
  metadata: {
    [APP_FORM_KEYS.APP_NAME]: "Your App",
    app_category: "Category",
    [APP_FORM_KEYS.PLAYSTORE_LINK]: "",
    [APP_FORM_KEYS.APP_STORE_LINK]: "",
  },
};

export const APP_STATUS = {
  PURCHASED: 1,
  DATA_SUBMITTED: 2,
  IN_PROGRESS: 3,
  LIVE: 4,
  DATA_UPDATE_REQUESTED: 5,
  DATA_UPDATED: 6,
  DATA_UPDATE_FAILED: 7,
};
